var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding fit scroll" }, [
    _c("div", { staticClass: "q-pb-xl" }, [
      _c("div", { staticClass: "q-pb-xl" }, [
        _c("h5", [_vm._v(" Drivers License ")]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Drivers License State",
                    value: _vm.driversLicenseForm.LK_STATE_ID,
                    options: _vm.stateOptions,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.driversLicenseForm.LK_STATE_ID.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.driversLicenseForm
                          .LK_STATE_ID.$invalid
                      }
                    ],
                    disable: true
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error:
                    _vm.validation.driversLicenseForm.DRIVERS_LICENSE.$error,
                  "error-label": _vm.driversLicenseError
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Drivers License Number",
                    disable: true || !_vm.driversLicenseForm.LK_STATE_ID,
                    value: _vm.driversLicenseForm.DRIVERS_LICENSE,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.driversLicenseForm.LK_STATE_ID.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.driversLicenseForm
                          .LK_STATE_ID.$invalid
                      }
                    ],
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "q-pb-xl" }, [
        _c("h5", [_vm._v(" Details ")]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_LAST_NAME.$error,
                  "error-label": "Last name is required"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Last Name",
                    value: _vm.studentForm.STUDENT_LAST_NAME,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_LAST_NAME.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm.STUDENT_LAST_NAME
                          .$invalid
                      }
                    ],
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_FIRST_NAME.$error,
                  "error-label": "First name is required"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "First Name",
                    value: _vm.studentForm.STUDENT_FIRST_NAME,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_FIRST_NAME.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm
                          .STUDENT_FIRST_NAME.$invalid
                      }
                    ],
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Middle Name",
                    value: _vm.studentForm.STUDENT_MIDDLE_NAME,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Suffix",
                    value: _vm.studentForm.STUDENT_SUFFIX,
                    "display-value": _vm.selectedSuffix,
                    options: _vm.suffixOptions,
                    disable: true
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_DOB.$error,
                  "error-label": "Invalid Date"
                }
              },
              [
                _c("sl-date-time", {
                  attrs: {
                    value: _vm.studentForm.STUDENT_DOB,
                    "float-label": "Date of Birth",
                    type: "date",
                    width: "100%",
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Gender",
                    value: _vm.studentForm.STUDENT_GENDER,
                    options: _vm.genderOptions,
                    disable: true
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-6",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_EMAIL.$error,
                  "error-label": "Must be a valid email"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Email",
                    value: _vm.studentForm.STUDENT_EMAIL,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-6",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_PHONE.$error,
                  "error-label": "Phone must be numeric"
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "999-999-9999",
                      expression: "'999-999-9999'"
                    }
                  ],
                  attrs: {
                    "float-label": "Phone",
                    type: "tel",
                    value: _vm.studentForm.STUDENT_PHONE,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_PHONE.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm.STUDENT_PHONE
                          .$invalid
                      }
                    ],
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }